import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@americanexpress/dls-react';

const INITIAL_VISIBLE_COUNT = 12;

const HotelFacilities = ({ facilities = [] }) => {
  const [showAll, setShowAll] = useState(false);

  if (facilities.length === 0) {
    return null;
  }

  const visibleFacilities = showAll ? facilities : facilities.slice(0, INITIAL_VISIBLE_COUNT);
  const hasMore = facilities.length > INITIAL_VISIBLE_COUNT;

  return (
    <>
      <ul className="list margin-2-t pad-l" style={{ columns: '3 200px', gap: '1rem' }}>
        {visibleFacilities.map((facility) => (
          <li key={facility} className="pad-1-b body">
            {facility}
          </li>
        ))}
      </ul>
      {hasMore && (
        <Button
          variant="secondary"
          className="margin-1-t"
          onClick={() => setShowAll((prev) => !prev)}
        >
          {showAll ? 'Hide All Facilities' : 'Show All Facilities'}
        </Button>
      )}
    </>
  );
};

HotelFacilities.propTypes = {
  facilities: PropTypes.arrayOf(PropTypes.string),
};

export default HotelFacilities;
